export default {
  view: {
    attendance: {
      filter: {
        title: 'Filters',
        eventTypes: 'Event Types',
        all: 'All',
        none: 'None',
        search: 'Search',
      },
      origin: {
        email: 'E-mail',
        order: 'Order',
        calendar: 'Calendar',
        process: 'Process',
        conversation: 'Conversation',
        surveynps: 'NPS Survey',
        call: 'Call',
        audio: 'Visit Audio',
        evotalks: 'EvoTalks',
        insight: 'Customer Insight',
      },
      card: {
        insight: {
          newTranscriptions: 'New visits',
          newTranscriptionsHint: 'There are transcribed visits not covered by this insight yet. Refresh to include them.',
          refresh: 'Refresh insight',
          upToDate: 'The insight is already up to date with the transcribed visits.',
          generationFailed: 'Could not generate the insight right now. Please try again shortly.',
          noTranscriptions: 'There are no transcribed visits to generate the insight.',
          generated: 'Insight generated.',
          generatedFrom: 'Generated with AI from the visit audios of the sales rep {nome}',
          notGenerated: 'Not generated',
          notGeneratedHint: 'The visit audios of the sales rep {nome} have no insight generated yet. Generate it to see the AI analysis.',
          generate: 'Generate insight',
          periodFilterHint: 'This insight reflects the client\'s current state and is not affected by the period filter.',
        },
        email: {
          to: 'To:',
        },
        order: {
          situation: 'Status',
          netValue: 'Net Value',
          discountPct: '% Discount',
          discountValue: 'Discount Value',
          grossValue: 'Gross Value',
          viewDetails: 'View full details',
          notFound: 'Order data not found',
        },
        call: {
          protocol: 'Protocol',
          type: 'Type',
          notFound: 'Call data not found',
          contact: 'Contact/Number',
          duration: 'Duration',
        },
        conversation: {
          contact: 'Contact/Number',
          department: 'Department',
          startDate: 'Start',
          endDate: 'End',
        },
        nps: {
          situation: 'Status',
          order: 'Order',
          score: 'Score',
          comment: 'Comment',
        },
        process: {
          follow: 'Follow',
          openError: 'Unable to open the process.',
        },
      },
      engagementCard: {
        title: 'Engagement Score',
        tooltip: 'The score is calculated based on the frequency and recency of client interactions (emails, orders, conversations, calls and visits). More recent and frequent interactions raise the score. 0–39% = low engagement | 40–69% = medium engagement | 70–100% = highly active client (Power User).',
        lowIntent: 'LOW INTENT',
        powerUser: 'POWER USER',
        totalInteractions: 'Total Interactions',
        lastActivity: 'Last Activity',
        noData: 'No engagement data',
        fewMinutesAgo: 'a few min ago',
        hoursAgo: '{hours}h ago',
        oneDayAgo: '1 day ago',
        daysAgo: '{days} days ago',
        oneMonthAgo: '1 month ago',
        monthsAgo: '{months} months ago',
      },
      statsCard: {
        title: 'Period Summary',
        events: 'Events',
        moved: 'Total Value',
        distributionByType: 'Distribution by type',
        noEvents: 'No events in this period',
      },
    },
    financialInformation: {
      title: 'Client Panel - Financial Information',
      clickHereToExportContracts: 'Click here to export the receivables to Excel',
      print: 'Duplicate',
      defaulting: 'Overdue',
      filter: {
        searchOnContracts: 'Search receivables',
        issuancePeriod: 'Issuance period',
        expirePeriod: 'Due period',
        onlyExpiredContracts: 'Only overdue receivables',
        searchBySituation: 'Status',
      },
      grid: {
        contractName: 'Receivable',
        holder: 'Holder',
        origin: 'Origin',
        situation: 'Status',
        issuanceDate: 'Issuance',
        dueDate: 'Due Date',
        originalDueDate: 'Original Due Date',
        paymentMethod: 'Payment Method',
        debtSettlementDate: 'Settlement',
        defaultingDays: 'Days Overdue',
        netValue: 'Net Value',
        order: 'Order',
        position: 'Position',
        cnpj: 'Tax ID',
        corporateName: 'Corporate Name',
        balance: 'Balance',
        occurrences: 'Occurrences',
        invoiceNumber: 'Invoice Number',
      },
      card: {
        creditLimitBalance: 'Credit limit balance',
        creditLimit: 'Credit limit',
        orderPlusDocuments: 'Orders + receivables',
        defaultingDays: 'Days overdue',
        overdueValue: 'Overdue (Value)',
        paidLateQuantity: 'Paid late',
      },
    },
    process: {
      grid: {
        queue: 'Queue',
      },
    },
    order: {
      grid: {
        invoiceNumber: 'Invoice number',
        invoiceIssuanceDate: 'Invoice issuance date',
      },
    },
    chatReport: {
      filter: {
        classification: 'Classification',
        noClassification: 'No classification',
        mistake: 'Mistake',
        undefined: 'Unassigned',
      },
      grid: {
        classification: 'Classification',
      },
    },
  },
  chatListItem: {
    contact: {
      notLocated: 'Contact not assigned',
    },
  },
  chatCallerButton: {
    messages: {
      errorOnGetPermissions: 'There was an error checking your permissions to manage WhatsApp. Please try again.',
      whatsappDisabled: 'WhatsApp not enabled',
      youDoNotHavePermissiontoManageWhatsApp: 'You do not have permission to manage WhatsApp',
      couldNotFoundAValidWaIdForNumber: 'Could not find a valid WhatsApp for the number {contactNumber}',
      InactiveContact: 'This contact is inactive. Reactivate it to start a conversation.',
      syncingWithEvoTalks: 'Syncing with EvoTalks, please wait a moment',
      evoTalksSyncIncomplete: 'Could not sync the contact/company with EvoTalks. Check the synchronization screen.',
      popupBlocked: 'The browser blocked opening EvoTalks. Allow pop-ups for this site and click again.',
      noQueueAvailable: 'Your user is not part of any EvoTalks queue. Check the agent link on the synchronization screen.',
    },
    queueDialog: {
      title: 'Open conversation on EvoTalks',
      subtitle: 'Choose the service queue',
      templateSubtitle: 'Queue {queue} — choose the message template',
      inService: 'In service',
      noTemplates: 'No approved template on this queue.',
      searchTemplate: 'Search template',
      noTemplatesFound: 'No template found.',
      loadTemplatesError: 'Could not load the templates of this queue.',
      noVariables: 'This template has no variables.',
      variable: 'Variable {marker}',
      imageHeader: 'Template image',
      unsupported: 'This template has a variable in the header or buttons, which the CRM does not fill yet. Choose another template.',
      chatOpenTitle: 'Chat already open',
      chatOpen: 'The contact already has an open chat on this queue. The conversation opens without a template.',
      chatOtherTitle: 'Contact in service',
      changeQueue: 'Change queue',
      changeTemplate: 'Change template',
      openWithoutTemplate: 'Open without template',
      openChat: 'Open conversation',
      send: 'Send and open conversation',
    },
    templateMessages: {
      chatWithOtherAttendant: 'The contact is being served by another attendant on this queue.',
      chatAlreadyOpen: 'The contact already has an open chat on this queue. The conversation was opened without sending the template.',
      sendError: 'Could not send the template. Try again.',
    },
  },
  evoTalksActions: {
    label: {
      syncClient: 'Sync Client to EvoTalks (BETA)',
      syncProspect: 'Sync Prospect to EvoTalks (BETA)',
      syncContacts: 'Sync Contacts to EvoTalks (BETA)',
      synced: 'Synced',
      lastSync: 'Last sync: {date}',
    },
    messages: {
      companySynced: 'Company synced with EvoTalks',
      companySyncError: 'Error syncing with EvoTalks',
      contactsSynced: 'Contacts synced: {synced}/{total}',
      contactsSyncError: 'Error syncing contacts',
    },
  },
  chat: {
    filters: {
      unread: 'Unread',
      pinned: 'Pinned',
      unassigned: 'Unassigned',
    },
    messages: {
      errorTogglingPin: 'Error toggling pin/unpin conversation',
    },
    dialog: {
      salesChannel: {
        title: 'Sales Channel',
        message: 'The sales channel number has not been configured. Please configure it to continue.',
      },
    },
  },
  clientSearchField: {
    client: 'Client',
    prospect: 'Prospect',
    searchForAClient: 'Search for a client',
    searchForAProspect: 'Search for a prospect',
    copyText: 'Copy name',
    textCopied: 'Name copied to clipboard',
    copyFailed: 'Failed to copy name',
  },
  prospectForm: {
    integrationFields: {
      sectionTitle: 'Integration Fields',
      empty: 'No integration field filled',
      emptyDef: 'No integration field registered',
    },
    warn: {
      mainContactNotUpdated: 'The prospect was saved, but the main contact name could not be updated.',
    },
  },
  activityCalendarEventForm: {
    privateSchedule: 'Private Schedule',
    viewAllGroupClients: 'View in All Group Clients',
  },
  attachmentsViewer: {
    type: {
      frontage: 'Storefront photo',
      order: 'Orders',
      visitation: 'Visits',
      other: 'Other attachments',
      processo: 'Processes',
    },
    filter: {
      searchOnAttachments: 'Search attachments',
      type: 'Attachment type',
      user: 'Added by',
      flow: 'Flow',
    },
    budget: 'Budget',
    error: {
      openProcess: 'Unable to open process.',
      loadProcess: 'Unable to load process attachments.',
    },
  },
  salesFunnel: {
    tabTitle: 'Process {id} | {flow}',
    openError: 'Unable to open the sales funnel for this process.',
  },
  process: {
    tabTitle: 'Process {id}',
    newTabTitle: 'New process | {flow}',
  },
  crmAttachmentsViewerDetailsDialog: {
    label: {
      date: 'Date',
      type: 'Attachment type',
      description: 'Description',
    },
    type: {
      frontage: 'Storefront photo',
      order: 'Orders',
      visitation: 'Visits',
      other: 'Other attachments',
      processo: 'Processes',
    },
  },
};
